// extracted by mini-css-extract-plugin
module.exports = {"updateAvailableInfoRoot":"updateAvailableInfoRoot--a961e"};